import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { MultipleSelectAutocomplete } from "./MultipleSelectAutocomplete";

export const StepThreeTests = ({
  onTestSelectionChange,
  testCompendiumList,
  selectedTest,
  setSelectedTest,
  selectedSubTests,
  setSelectedSubTests
}) => {
  useEffect(() => {
    // Automatically select all subtests of newly selected main tests
    const updateSelectedSubTests = selectedTest.reduce((acc, mainTest) => {
      acc[mainTest.testOrPanelName] = mainTest.specifications.map(subtest => subtest.testName);
      return acc;
    }, {});
    setSelectedSubTests(updateSelectedSubTests);
  }, [onTestSelectionChange, selectedTest, setSelectedSubTests]);

  const handleSubTestSelection = (mainTest, subTest) => {
    const updatedSubTests = { ...selectedSubTests };
    if (updatedSubTests[mainTest]) {
      if (updatedSubTests[mainTest].includes(subTest)) {
        updatedSubTests[mainTest] = updatedSubTests[mainTest].filter(test => test !== subTest);
      } else {
        updatedSubTests[mainTest].push(subTest);
      }
    } else {
      updatedSubTests[mainTest] = [subTest];
    }
    setSelectedSubTests(updatedSubTests);
  };
  console.log("selectedTest", selectedTest);

  return (
    <div className="step-form">
      <h3>Tests</h3>
      <Form>
        <Form.Group controlId="formBasicTests">
          <Form.Label>Available Tests</Form.Label>
          <MultipleSelectAutocomplete value={selectedTest} setValue={setSelectedTest} mapOptions={testCompendiumList} />
        </Form.Group>
        <h3
          style={{
            marginTop: "20px"
          }}
        >
          Panel
        </h3>
        {selectedTest.map(
          (mainTest, index) =>
            mainTest?.panel && (
              <div key={index} style={{ marginTop: "10px" }}>
                <h4>{mainTest.testOrPanelName}</h4>
                <Form.Group>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px"
                    }}
                  >
                    {mainTest.specifications.map(subtest => (
                      <Form.Check
                        // className="form-check-ques"
                        key={subtest.testCode}
                        type="checkbox"
                        label={subtest.testName}
                        checked={selectedSubTests[mainTest.testOrPanelName]?.includes(subtest.testName)}
                        onChange={() => handleSubTestSelection(mainTest.testOrPanelName, subtest.testName)}
                        disabled={!subtest.editable}
                      />
                    ))}
                  </div>
                </Form.Group>
                <div
                  style={{
                    marginTop: "20px",
                    marginBottom: "20px",
                    borderBottom: "1px solid #e0e0e0"
                  }}
                />
              </div>
            )
        )}
        {selectedTest.filter(test => !test.panel).length > 0 && (
          <div>
            <h4>Individual</h4>
            <Form.Group>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px"
                }}
              >
                {selectedTest
                  .filter(test => !test.panel)
                  .map(subtest => (
                    <Form.Check
                      className="form-check-ques"
                      key={subtest.testCode}
                      type="checkbox"
                      label={subtest.testOrPanelName}
                      checked={selectedSubTests[subtest.testOrPanelName]}
                      onChange={() => handleSubTestSelection(subtest.testOrPanelName)}
                      disabled={!subtest.editable}
                    />
                  ))}
              </div>
            </Form.Group>
          </div>
        )}
      </Form>
    </div>
  );
};
